import React from 'react';
import EditIcon from '@material-ui/icons/Edit';

import Bloque from '../../commons/Bloque';
import CheckBox from '../../commons/CheckBox';
import TablaBody from '../../commons/TablaBody';
import TablaSearch from '../../commons/TablaSearch';
import Paginacion from '../../commons/Paginacion';
import { useTablaFilter } from '../../commons/Formulario';

const ManualList = () => {
  const { setSelectedItem } = useTablaFilter();

  const columns = [
    {
      key: 'mn',
      align: 'center',
      content: (item) => (
        <EditIcon
          onClick={() => setSelectedItem(item)}
          style={{ color: 'green', cursor: 'pointer' }}
        />
      ),
    },
    {
      key: 'cm',
      label: 'Código',
    },
    {
      key: 'nm',
      label: 'Nombre',
    },
    {
      key: 'st',
      label: 'Estado de registro',
      align: 'center',
      content: (item) => <CheckBox checked={item.st} disabled />,
    },
  ];

  return (
    <Bloque titulo="Manuales">
      <div className="op-table">
        <TablaSearch />
        <TablaBody columns={columns} />
        <Paginacion />
      </div>
    </Bloque>
  );
};

export default ManualList;
